import "classlist-polyfill";

// polyfill for .closest
(function (ELEMENT) {
	ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;
	ELEMENT.closest = ELEMENT.closest || function closest(selector) {
		if (!this) return null;
		if (this.matches(selector)) return this;
		if (!this.parentElement) {
			return null
		} else return this.parentElement.closest(selector)
	};
}(Element.prototype));

(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('append')) {
			return;
		}
		Object.defineProperty(item, 'append', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function append() {
				let argArr = Array.prototype.slice.call(arguments),
					docFrag = document.createDocumentFragment();

				argArr.forEach(function (argItem) {
					let isNode = argItem instanceof Node;
					docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
				});

				this.appendChild(docFrag);
			}
		});
	});
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

// smooth scroll polyfill
window.smoothScrollTo = function(endX, endY, duration) {
	let startX = window.scrollX || window.pageXOffset,
		startY = window.scrollY || window.pageYOffset,
		distanceX = endX - startX,
		distanceY = endY - startY,
		startTime = new Date().getTime();

	// Easing function
	let easeInOutQuart = function(time, from, distance, duration) {
		if ((time /= duration / 2) < 1) return distance / 2 * time * time * time * time + from;
		return -distance / 2 * ((time -= 2) * time * time * time - 2) + from;
	};

	let timer = window.setInterval(function() {
		let time = new Date().getTime() - startTime,
			newX = easeInOutQuart(time, startX, distanceX, duration),
			newY = easeInOutQuart(time, startY, distanceY, duration);
		if (time >= duration) {
			window.clearInterval(timer);
		}
		window.scrollTo(newX, newY);
	}, 1000 / 60); // 60 fps
};
